import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=28287d77&scoped=true"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=28287d77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28287d77",
  null
  
)

export default component.exports